import SelectInput from 'components/form/input/SelectInput'
import React from 'react'

export default function FilterSelectInput(name, label, options, optionsParse) {
    return {
        render: (props) => <SelectInput sx={{ width: '100%' }} name={name} label={label} options={options} />,
        compare: (value, row, filterValues) => {
            if (value) {                               
                let compareValue = value
                if (optionsParse) {
                    let indexOf = options.indexOf(value);
                    compareValue = optionsParse[indexOf]
                }


                if (row.status === compareValue) {
                    return true
                }

                return false
            }
            return true
        }
    }
}
